import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables}) => ({
  orderAssignAccordion: {
    display: 'flex',
    width: '100%',
    padding: variables?.spacingB,
    '& ul': {
        listStyle: 'none',
    }
  },
  itemNoData: {
    display: 'flex',
    width: '100%',
    padding: variables?.spacingD,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default styles;
